import { Container, styled } from "@bvhi/ui-base";
import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { BVHIAppBar } from "../../../components/bvhi-app-bar";
import { BVHIBounceLoader } from "../../../components/bvhi-bounce-loader";
import { BVHIFooter } from "../../../components/bvhi-footer";
import { AppNavigationConfig } from "../../../config/navigation";

const GridContainer = styled("div")({
  height: "100svh",
  width: "100svw",
  maxWidth: "100%",
  display: "grid",
  overflowX: "hidden",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "64px 1fr 64px",
  gridTemplateAreas: `"header" "content" "footer"`,
  alignItems: "stretch",
  justifyItems: "stretch",
  alignContent: "stretch",
  justifyContent: "stretch",
});

const GridHeaderItem = styled("div")({
  gridArea: "header",
});

const GridContentItem = styled("div")(({ theme }) => ({
  gridArea: "content",
  padding: theme.spacing(2),
}));

const GridFooterItem = styled("div")({
  gridArea: "footer",
});

export const PublicLayoutView = () => {
  return (
    <>
      <GridContainer>
        <GridHeaderItem>
          <BVHIAppBar />
        </GridHeaderItem>

        <GridContentItem>
          <Suspense fallback={<BVHIBounceLoader />}>
            <Container component="main">
              <Outlet />
            </Container>
          </Suspense>
        </GridContentItem>

        <GridFooterItem>
          <BVHIFooter navigationConfig={AppNavigationConfig} />
        </GridFooterItem>
      </GridContainer>
    </>
  );
};
